import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/Services/Event/event.service';

import { faThumbsUp, faThumbsDown, faTrash, faComment, faPlusCircle, faClosedCaptioning,faPencilAlt , faSlash } from '@fortawesome/free-solid-svg-icons';
import { CommentaireService } from 'src/app/Services/Commentaire/commentaire.service';
import { Event } from 'src/app/Models/Event';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import {
  Form,
  FormBuilder,
  NgModel,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AlertService } from 'src/app/Services/User/alert.service';
import { ToastService } from 'src/app/Services/toast/toast.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit {
  id: any;
  nEvent : any ;  
  ListEvent: any;
  titre: string;
  date: string;
  category: String;
  location: String;
  user: string;
  faThumbsUp = faThumbsUp;
  faThumbsDown = faThumbsDown;
  faTrash = faTrash;
  faComment = faComment;
  nComment: any;
  nEvents: any;
  hideformevent = true;
  hideformupdateevent=true ; 
  event: any = {};
  selectedFile: File = null;
  hideimage = true;
  hideform = false;
  showmsg = true;
  msg = '';
  closeResult: string;
  faAdd=faPlusCircle;
  style1: string;
  isOpened: boolean;
  toggleStyle: string;
  faClose=faSlash;
  faPencilAlt=faPencilAlt;
  form: FormGroup;
  submitted = false;
 
  constructor(private modalService: NgbModal,
    private eventservice: EventService,
    private router: Router,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private commentaireservice: CommentaireService,
    private toast:ToastService
  ) { }
  validateDate(): void {
    const startDate = new Date(this.f.startime.value);
    const endDate = new Date(this.f.endtime.value);
  
    // Compare the date and time of the start and end times
    if (startDate.getTime() > endDate.getTime()) {
      // If the start time is later than the end time, clear the end time field
      this.form.patchValue({ endtime: '' });
    }
  }
  
  
  
  ngOnInit(): void {
    this.getAllEvents();
    this.hideSupp(this.id);
    this.hideUpp(this.id);
    this.hideFormEvent();
   
    this.form = this.formBuilder.group({
      titre:['',Validators.required],
      description: ['', Validators.required],
      // date:['',Validators.required],
      startime:['',Validators.required],
      endtime:['',Validators.required],
      image: ['', [Validators.required ]],
      category: ['', Validators.required],
      type: ['', Validators.required],
      availablePlaces:['',Validators.required],
      zoomlink:[''],
      location:['']
    });
      // Add conditional validators
      this.form.get('type').valueChanges.subscribe(value => {
        this.updateFormValidators(value);
      });
  }
  get f() {
    return this.form.controls;
  }
  updateFormValidators(value:string){
    const location =this.form.get('location');
    const zoomlink = this.form.get('zoomlink');
    //reset Validators 
    location.setValidators(null);
    zoomlink.setValidators(null);
    
    if(value=="Virtual")
    {
      zoomlink.setValidators([Validators.required]);
      
    }else if(value=="Physical"){
      
      location.setValidators([Validators.required]);
    }else if(value=="Hybrid"){
      location.setValidators([Validators.required]);
      zoomlink.setValidators([Validators.required]);
    }
    location.updateValueAndValidity();
    zoomlink.updateValueAndValidity();
  }
 
  openModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'block';
  }

  closeModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'none';
    this.submitted = false;

  }
  onSubmit(){
   this.id = localStorage.getItem('Id');
    this.submitted = true ; 
    // Stop here if the form is invalid
    
    if (this.form.invalid) {
    alert("error form");
    console.log('Form Valid:', this.form.valid);
console.log('Form Errors:', this.form.errors);

     return;
   }
   
   alert("test");
   const event = {
    titre:this.f.titre.value, 
    description: this.f.description.value,
    //date:this.f.date.value, 
    startime:this.f.startime.value , 
    endtime:this.f.endtime.value,
    category:this.f.category.value, 
    type:this.f.type.value,
    availablePlaces:this.f.availablePlaces.value,
    location:this.f.location.value,
    zoomlink:this.f.zoomlink.value,
   };

   this.eventservice.addeventwithpicture(event,this.id,this.selectedFile).subscribe(
    data=>{
      this.form.reset();
      console.log("Event added Succeffully ");
      this.toast.SuccessToast("Event Added Successfully !");
      this.router.navigate(['/home/events']);
    },
    err=>{
      console.error('Error adding opportunity:', err);
      this.toast.ErrorToast("Post not Added");
    }
   )
   this.closeModal() ;
   this.submitted = false;

  }

  toggle(){
    this.style1="flex";
    // this.style2="none";
    this.isOpened=true;
    this.toggleStyle="flex";

  }
  closeNote(){
    this.style1="none"
    this.isOpened=false;
  }
  openalert(contentalert) {
    this.modalService.open(contentalert, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getAllEvents() {
    this.eventservice.getAllEvents().subscribe(
      data => {
        this.ListEvent = data;
        this.nEvents = this.ListEvent.length;
        console.log(this.ListEvent);
      },
      error => {
        // Handle the error appropriately
        console.error('Failed to fetch events:', error);
      }
    );
  }

  setEventId(id: any) {
    localStorage.setItem("IdEvent", id);
    console.log(this.id);
  }

  
  
  hideUpp(id: any) {
    if (id == localStorage.getItem("Id")) {
      return false
    } else {
      return true
    }
  }

  SearchEventByTitre() {
    if (this.titre != "") {
      this.ListEvent = this.ListEvent.filter(res => {
        return res.titre.toLowerCase().match(this.titre.toLowerCase());
      });
    }
    else if (this.titre == "") {
      this.getAllEvents();
    }
  }

  SearchEventByDate() {
    if (this.date != "") {
      this.ListEvent = this.ListEvent.filter(res => {
        return res.date.toLowerCase().match(this.date.toLowerCase());
      });
    }
    else if (this.date == "") {
      this.getAllEvents();
    }
  }

  deleteEvent() {
    this.eventservice.deleteEvent(localStorage.getItem("IdEvent")).subscribe(
      data => {
        return data;
      }
    );
  }

  hideSupp(id: any) {
    if (id == localStorage.getItem("Id")) {
      return false
    } else {
      return true
    }
  }

  /*CountCommentaireByEventId(id: any) {
    return this.commentaireservice.countCommentaireByEventId(id).subscribe(
      data => {
        this.nComment = data;
        return this.nComment;
      }
    );
  }
*/
  likeEvent(id: any) {
    this.eventservice.likeEvent(id).subscribe(
      data => {
        let hidelike = true;
        let hidedislike = false;
        return data;
      }
    )
  }

  dislikeEvent(id: any) {
    this.eventservice.disLikeEvent(id).subscribe(
      data => {
        let hidelike = false;
        let hidedislike = true;
        return data;
      }
    )
  }

  hideFormEvent() {
    if (localStorage.length != 0) {
      this.hideformevent = false;
    }
  }
/*
  addEvent(event: Event) {
    this.id = localStorage.getItem("Id")
    this.eventservice.addEvent(event, this.id).subscribe(
      data => {
        event = data;
        this.hideform = true;
        this.hideimage = false;
        localStorage.setItem("IdEvent", event._id)
        return event;
      }
    )
  }
*/
  HideFormUpdatePost(){
    if (localStorage.length != 0) {
      this.hideformupdateevent = false;
    }
  }


  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
    console.log(this.selectedFile);
  }

  addImage() {
    this.id = localStorage.getItem("IdEvent");
    const file = new FormData();
    file.append('image', this.selectedFile, this.selectedFile.name)
    console.log(file);
    this.eventservice.addImage(file, this.id).subscribe(
      data => {
        this.showmsg = false;
        this.msg = "Enjoy ! "
        this.toast.SuccessToast('Your Event Added HF!');
        return data;
      });
  }
  topFunction() {
   
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  onEventTypeChange() {
    if (this.event.type !== 'physical') {
      // Reset the location value when event type is changed to something other than physical
      this.event.location = '';
    }
    if (this.event.type !== 'virtual') {
      // Reset the location value when event type is changed to something other than physical
      this.event.location = '';
    }
  }

}